import axios from 'axios';

const apiURL: string | undefined = process.env.REACT_APP_API_URL;

const token: string | undefined = localStorage.token;

export const downloadOrdersReport = async (qParams: any) => {
  try {
    const headers: object = {
      ContentType: 'application/octet-stream',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      Authorization: 'Bearer ' + token
    };
    const res = await axios.get(`${apiURL}/seller/generateOrderReport`, {
      params: qParams,
      responseType: 'blob',
      headers: headers
    });
    var blob = new Blob([res.data]);
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `ordenes.xlsx`;
    link.click();
  }
  catch (e) {
    console.error(e);
    return null
  }
}

export const generateAssociateReport = async (qParams: any, role:string) => {
  try {
    const headers: object = {
      ContentType: 'application/octet-stream',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      Authorization: 'Bearer ' + token
    };
    const res = await axios.get(`${apiURL}/${role}/generateAssociateReport`, {
      params: qParams,
      responseType: 'blob',
      headers: headers
    });
    var blob = new Blob([res.data]);
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `ordenes-asociado.xlsx`;
    link.click();
  }
  catch (e) {
    console.error(e);
    return null
  }
}
